export enum DialogFilterTypes {
    DisplayMetrics = 'display_metrics',
    TimePeriod = 'time_period',
    MetricRange = 'metric_range',
    SortOrder = 'sort_order',
    TimeRange = 'time_range',
    DisplayAttributes = 'display_attributes',
    DisplayAttributeMetrics = 'display_attribute_metrics'
}
